import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-locations',
  templateUrl: './turns-locations.component.html',
  styleUrls: ['./turns-locations.component.scss']
})
export class TurnsLocationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
